import moment from 'moment';

export const BULK_EXPORT_PERIODS = {
  LAST_WEEK: 'last_week',
  LAST_MONTH: 'last_month',
  CUSTOM: 'custom'
};

export const BULK_EXPORT_PERIOD_OPTIONS = [
  {value: BULK_EXPORT_PERIODS.LAST_WEEK, label: 'Last week'},
  {value: BULK_EXPORT_PERIODS.LAST_MONTH, label: 'Last month'},
  {value: BULK_EXPORT_PERIODS.CUSTOM, label: 'Custom'}
];

export const BULK_EXPORT_REPORT_TYPES = [
  {value: 'sales_summary', label: 'Sales Summary'}
];

const DATE_FORMAT = 'YYYY-MM-DD';

// Calendar-aligned range in the location's timezone; [null, null] while a custom range is incomplete.
export const getBulkExportDateRange = (period, timezoneOffset, customRange) => {
  const now = moment().utcOffset(timezoneOffset || 0, false);
  switch (period) {
    case BULK_EXPORT_PERIODS.LAST_WEEK:
      return [
        now.clone().subtract(1, 'week').startOf('isoWeek').format(DATE_FORMAT),
        now.clone().subtract(1, 'week').endOf('isoWeek').format(DATE_FORMAT)
      ];
    case BULK_EXPORT_PERIODS.LAST_MONTH:
      return [
        now.clone().subtract(1, 'month').startOf('month').format(DATE_FORMAT),
        now.clone().subtract(1, 'month').endOf('month').format(DATE_FORMAT)
      ];
    default:
      return customRange?.[0] && customRange?.[1]
        ? [
            moment.utc(customRange[0]).format(DATE_FORMAT),
            moment.utc(customRange[1]).format(DATE_FORMAT)
          ]
        : [null, null];
  }
};

export const formatBulkExportRange = (from, to) => {
  if (!from || !to) return '';
  const start = moment.utc(from);
  const end = moment.utc(to);
  const startFormat = start.year() === end.year() ? 'MMM D' : 'MMM D, YYYY';
  return `${start.format(startFormat)} - ${end.format('MMM D, YYYY')}`;
};

export const BULK_EXPORT_MAX_RANGE_MONTHS = 6;

// Last selectable end day for a range starting on `from`.
export const getBulkExportMaxEndDate = (from) =>
  moment
    .utc(from)
    .add(BULK_EXPORT_MAX_RANGE_MONTHS, 'months')
    .subtract(1, 'day')
    .format(DATE_FORMAT);

export const isBulkExportRangeTooLong = (from, to) =>
  moment.utc(to).isAfter(moment.utc(getBulkExportMaxEndDate(from)), 'day');

export const getBulkExportSubmitError = ({selectedCount, from, to}) => {
  if (selectedCount < 1) return 'Select at least one location';
  if (!from || !to) return 'Select the time period';
  if (isBulkExportRangeTooLong(from, to))
    return `Select a period of up to ${BULK_EXPORT_MAX_RANGE_MONTHS} months`;
  return null;
};
